module.exports = __webpack_public_path__ + "media/images/march8/march8-template-am-e4d88faa362d2e97755ef4cd0f895a59.png";